if (!customElements.get('available-offers')) {
  customElements.define(
    'available-offers',
    class AvailableOffersWidget extends HTMLElement {
      constructor() {
        super();
        this.availableOfferSection = this.querySelector('.available-offer-section');
        this.autoApplyDiscount = this.availableOfferSection.dataset.autoApplyDiscount;
        this.selectedCode = '';
        this.availableCode = pdpDiscountEnabled() ? [
          'annual-199-subscription-new', 
          'annual-subscription-new', 
          '12-month-plan', 
          'minimalist-digital-silk-sonder-membership-12-month',
          'digital-only-silk-sonder-membership-annual'
        ].includes(this.availableOfferSection.dataset.productHandle) ? 'FREEMONTH' : 'FIVEOFF' : '';
        this.handleItemClick = this.handleItemClick.bind(this);
        
        this.applyButtons = this.querySelectorAll('.available-offer-item__apply');
        this.applyButtons.forEach(offerItem => offerItem.addEventListener('click', this.handleItemClick));
        document.addEventListener('availableDiscountCodeChanged', (ev) => {
          this.availableCode = ev.detail.code;
          if (this.availableCode !== this.selectedCode) {
            this.selectedCode = '';
            this.renderApplyButtons();
            document.dispatchEvent(new CustomEvent('discountCodeSelected', {
              detail: { code: this.selectedCode }
            }));
          }
          if (this.availableCode === 'FREEMONTH') {
            this.availableOfferSection.classList.remove('non-annual');
          } else {
            this.availableOfferSection.classList.add('non-annual');
          }
          this.availableOfferSection.querySelectorAll('.available-offer-item').forEach(elem => {
            if (elem.dataset.discountCode === this.availableCode) {
              elem.classList.add('enabled');
            } else {
              elem.classList.remove('enabled');
            }
          });
        });

        document.addEventListener('discountCodeSelected', (ev) => {
          if (ev.detail.appliedManually == true) {
            this.selectedCode = ev.detail.code;
          } else {
            this.selectedCode = this.autoApplyDiscount == "true" ? ev.detail.code : '';
          }
          this.renderApplyButtons();
        });

        document.dispatchEvent(new CustomEvent('discountCodeSelected', {
          detail: { code: this.autoApplyDiscount == "true" ? this.availableCode : '' }
        }));
        document.dispatchEvent(new CustomEvent('availableDiscountCodeChanged', {
          detail: { code: this.availableCode }
        }));
      }

      handleItemClick(ev) {
        let selectedCode = '';
        if (this.selectedCode !== this.availableCode) {
          selectedCode = this.availableCode;
        }

        document.dispatchEvent(new CustomEvent('discountCodeSelected', {
          detail: { code: selectedCode, appliedManually: true }
        }));
      }

      renderApplyButtons() {
        this.applyButtons.forEach(btn => {
          if (btn.dataset.code === this.selectedCode) {
            btn.innerHTML = 'REMOVE';
          } else {
            btn.innerHTML = 'APPLY';
          }
        })
      }
    }
  );
}
